export enum Roles {
  USER = 'user',
  ADMIN = 'admin',
}
